import {
  CloudUpload as CloudUploadIcon,
  Description as DescriptionIcon,
} from "@mui/icons-material";
import {
  Alert,
  alpha,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Container,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Snackbar,
  Stack,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import ChecklistDocumentosUpload from "../components/ChecklistDocumentosUpload";
import DocumentosPadraoUpload from "../components/DocumentosPadraoUpload";
import CharCounter from "../components/CharCounter";
import ErrosUploadDocumentosModal from "../components/ErrosUploadDocumentosModal";
import PdfOpenActionConfirmDialog from "../components/PdfOpenActionConfirmDialog";
import RevisaoProtocoloPanel from "../components/RevisaoProtocoloPanel";
import api from "../services/api";
import empreendimentoService from "../services/empreendimento";
import licencasService from "../services/licencas";
import protocoloService from "../services/protocolo";
import representadoService from "../services/representado";
// Responsável Técnico desativado — campo de busca comentado na tela
// import responsavelTecnicoService from "../services/responsavelTecnico";
import usuarioService from "../services/usuario";
import {
  DOCUMENTO_COMPROVANTE_PUBLICACAO_PEDIDO,
  modalidadeEnum,
  isProtocoloFlorestalEmpreendimento,
} from "../utils/constants";
import {
  isConsultor,
  montarRequerenteDeRepresentado,
  obterNomeExibicaoRepresentado,
} from "../utils/obterNomeExibicaoUsuario";

function obterArquivoDoItemChecklist(item, documentosChecklistFiles, documentos) {
  const fieldKey = `checklist_doc_${item.id}`;
  return documentosChecklistFiles[fieldKey] || documentos[fieldKey] || null;
}

function RevisaoDocumentoCard({ titulo, nomeArquivo, anexado }) {
  const theme = useTheme();
  const isAnexado = Boolean(anexado);

  return (
    <Grid item xs={12} sm={6}>
      <Box
        data-testid={
          isAnexado ? "revisao-documento-anexado" : "revisao-documento-nao-anexado"
        }
        sx={{
          display: "flex",
          alignItems: "center",
          p: 1.5,
          borderRadius: 1,
          bgcolor: isAnexado
            ? alpha(theme.palette.success.light, 0.1)
            : alpha(theme.palette.error.light, 0.1),
          border: `1px solid ${alpha(
            isAnexado ? theme.palette.success.main : theme.palette.error.main,
            0.2,
          )}`,
        }}
      >
        <Box
          component="span"
          sx={{
            color: isAnexado ? "success.main" : "error.main",
            mr: 1.5,
            fontSize: "1.2rem",
          }}
          aria-hidden="true"
        >
          {isAnexado ? "✓" : "!"}
        </Box>
        <Box sx={{ flexGrow: 1, overflow: "hidden" }}>
          <Typography variant="body2" fontWeight="medium">
            {titulo}
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              display: "block",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {isAnexado ? nomeArquivo : "Não anexado"}
          </Typography>
        </Box>
      </Box>
    </Grid>
  );
}

function NovaSolicitacao() {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const accentHeadingColor = isDarkMode
    ? theme.palette.primary.light
    : theme.palette.primary.dark;
  const infoTextColor = isDarkMode ? "info.light" : "info.dark";
  const primaryHeadingColor = isDarkMode ? "primary.light" : "primary.dark";
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const stepHeadingRef = useRef(null);
  const isPrimeiraExibicaoEtapa = useRef(true);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [envioConcluido, setEnvioConcluido] = useState(false);

  const [tiposLicenca, setTiposLicenca] = useState([]);
  const [tipoInputValue, setTipoInputValue] = useState("");
  const [empreendimentos, setEmpreendimentos] = useState([]);
  // const [responsaveisTecnicos, setResponsaveisTecnicos] = useState([]);
  // const [termoBuscaResponsavel, setTermoBuscaResponsavel] = useState("");
  // const [carregandoResponsaveis, setCarregandoResponsaveis] = useState(false);
  const [itensChecklist, setItensChecklist] = useState([]);
  const [documentosChecklistFiles, setDocumentosChecklistFiles] = useState({});
  const [comprovantePublicacaoPedido, setComprovantePublicacaoPedido] = useState(null);
  const [comprovantePublicacaoPedidoErro, setComprovantePublicacaoPedidoErro] = useState("");
  const [checklistNaoEncontrado, setChecklistNaoEncontrado] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [usuarioAtual, setUsuarioAtual] = useState(null);
  const [representados, setRepresentados] = useState([]);
  const [carregandoRepresentados, setCarregandoRepresentados] = useState(false);
  const [solicitadoPorRepresentado, setSolicitadoPorRepresentado] =
    useState(false);
  const [representadoId, setRepresentadoId] = useState("");
  const [openActionDialog, setOpenActionDialog] = useState({
    open: false,
    message: "",
    errors: [],
  });
  const [uploadErrorsDialog, setUploadErrorsDialog] = useState({
    open: false,
    message: "",
    errors: [],
  });

  const [formData, setFormData] = useState({
    tipoLicenca: null,
    modalidade: "",
    empreendimento: null,
    // responsavelTecnico: null,
    descricaoProjeto: "",
    areaTotal: "",
    observacoes: "",
    especificacao: "",
    documentos: {},
  });

  const fluxoProtocolo = isProtocoloFlorestalEmpreendimento(formData.empreendimento);

  const usuarioConsultor = isConsultor(usuarioAtual);
  const representadoSelecionado = solicitadoPorRepresentado
    ? representados.find(
        (representado) => String(representado.id) === String(representadoId),
      ) || null
    : null;
  const requerenteRepresentado = montarRequerenteDeRepresentado(
    representadoSelecionado,
  );

  // eslint-disable-next-line no-unused-vars
  const [documentos, setDocumentos] = useState({});
  const [documentosErros] = useState({});

  const steps = [
    "Informações Básicas",
    "Detalhes do Projeto",
    "Documentação",
    "Revisão",
  ];

  useEffect(() => {
    if (isPrimeiraExibicaoEtapa.current) {
      isPrimeiraExibicaoEtapa.current = false;
      return;
    }
    stepHeadingRef.current?.focus();
  }, [activeStep]);

  const carregarTiposLicenca = async (nome) => {
    try {
      const response = await api.get("TipoLicenca/GetByNomeAsync", {
        params: { nome },
      });

      setTiposLicenca(response.data || []);
    } catch (error) {
      setError(
        "Não foi possível carregar os tipos de licença. Por favor, tente novamente mais tarde.",
      );
    }
  };

  const buscarDocumentosDoChecklist = async (tipoLicenca, empreendimento, modalidadeParam) => {
    if (
      !tipoLicenca?.id ||
      !empreendimento ||
      modalidadeParam === null ||
      modalidadeParam === undefined ||
      modalidadeParam === ""
    ) {
      setItensChecklist([]);
      setChecklistNaoEncontrado(false);
      return;
    }

    const modalidadeId = parseInt(modalidadeParam, 10);
    if (isNaN(modalidadeId)) return;

    try {
      const response = await api.get(`/Checklist/filtro`, {
        params: {
          tipoLicencaId: tipoLicenca.id,
          grupoAtividade: empreendimento.grupoAtividade,
          atividadeEmpreendimento: empreendimento.atividadeEmpreendimento,
          modalidade: modalidadeId,
        },
      });

      const itensList = Array.isArray(response.data)
        ? response.data
        : response.data?.itensChecklist || [];

      const itens = itensList.map((item) => ({
        id: item.id,
        descricao: item.descricao,
        observacoes: item.observacoes,
        obrigatorio: item.obrigatorio,
      }));
      setItensChecklist(itens);
      setChecklistNaoEncontrado(false);
    } catch (err) {
      setItensChecklist([]);
      if (err?.response?.status === 404) {
        setChecklistNaoEncontrado(true);
      } else {
        setChecklistNaoEncontrado(false);
      }
    }
  };

  const carregarEmpreendimentos = async () => {
    try {
      const data = await empreendimentoService.listar(empreendimentos);
      setEmpreendimentos(data);
    } catch (error) {
      setError(
        "Não foi possível carregar os empreendimentos. Por favor, tente novamente mais tarde.",
      );
    } finally {
    }
  };

  useEffect(() => {
    carregarTiposLicenca(tiposLicenca);
    usuarioService.obterDados().then(setUsuarioAtual).catch(() => setUsuarioAtual(null));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!usuarioConsultor) return undefined;

    let cancelado = false;
    setCarregandoRepresentados(true);
    representadoService
      .listar()
      .then((itens) => {
        if (!cancelado) setRepresentados(itens);
      })
      .catch(() => {
        if (!cancelado) {
          setError(
            "Não foi possível carregar os representados. Por favor, tente novamente mais tarde.",
          );
        }
      })
      .finally(() => {
        if (!cancelado) setCarregandoRepresentados(false);
      });

    return () => {
      cancelado = true;
    };
  }, [usuarioConsultor]);

  useEffect(() => {
    buscarDocumentosDoChecklist(formData.tipoLicenca, formData.empreendimento, formData.modalidade);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.empreendimento, formData.tipoLicenca, formData.modalidade]);

  useEffect(() => {
    carregarEmpreendimentos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   const buscarResponsaveisTecnicos = async () => {
  //     if (!termoBuscaResponsavel || termoBuscaResponsavel.length < 3) {
  //       return;
  //     }
  //
  //     setCarregandoResponsaveis(true);
  //     try {
  //       const data = await responsavelTecnicoService.listar({
  //         search: termoBuscaResponsavel,
  //       });
  //       setResponsaveisTecnicos(data);
  //     } catch (error) {
  //     } finally {
  //       setCarregandoResponsaveis(false);
  //     }
  //   };
  //
  //   const timeoutId = setTimeout(buscarResponsaveisTecnicos, 500);
  //   return () => clearTimeout(timeoutId);
  // }, [termoBuscaResponsavel]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "areaTotal") {
      const regex = /^\d*\.?\d{0,2}$/;
      if (value === "" || regex.test(value)) {
        setFormData((prev) => ({
          ...prev,
          [name]: value,
        }));
      }
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSolicitadoPorRepresentadoChange = (event) => {
    const marcado = event.target.checked;
    setSolicitadoPorRepresentado(marcado);
    if (!marcado) {
      setRepresentadoId("");
    }
  };

  const anexarDadosDoRepresentado = (formDataToSend) => {
    formDataToSend.append(
      "solicitadoPorRepresentado",
      solicitadoPorRepresentado ? "true" : "false",
    );
    if (solicitadoPorRepresentado) {
      formDataToSend.append("representadoId", representadoId);
    }
  };

  const handleNext = () => {
    let isValid = true;

    if (activeStep === 0) {
      if (!formData.tipoLicenca) {
        setError("Escolha um Tipo de Licença válido nas opções.");
        return false;
      } else if (formData.modalidade === "" || formData.modalidade === null || formData.modalidade === undefined) {
        setError("Por favor, selecione uma modalidade.");
        isValid = false;
      } else if (!formData.empreendimento) {
        setError("Por favor, selecione um empreendimento.");
        isValid = false;
      } else if (solicitadoPorRepresentado && !representadoSelecionado) {
        setError("Por favor, selecione o representado.");
        isValid = false;
      } else {
        setError("");
      }
    } else if (activeStep === 1) {
      if (fluxoProtocolo) {
        if (!formData.especificacao?.trim()) {
          setError("Por favor, preencha a especificação.");
          isValid = false;
        } else if (formData.especificacao.length > 100) {
          setError("A especificação deve ter no máximo 100 caracteres.");
          isValid = false;
        } else {
          setError("");
        }
      } else if (!formData.descricaoProjeto) {
        setError("Por favor, preencha a descrição do projeto.");
        isValid = false;
      } else if (!formData.areaTotal || parseFloat(formData.areaTotal) <= 0) {
        setError("Por favor, informe a área total do projeto.");
        isValid = false;
      } else {
        const areaStr = formData.areaTotal.toString();
        const decimalPart = areaStr.split(".")[1];

        if (decimalPart && decimalPart.length > 2) {
          setError("A área total não pode ter mais de 2 casas decimais.");
          isValid = false;
        } else {
          setError("");
        }
      }
    } else if (activeStep === 2) {
      const documentosObrigatoriosNaoPreenchidos = itensChecklist.filter(
        (item) => {
          if (!item.obrigatorio) return false;
          const fieldKey = `checklist_doc_${item.id}`;
          const temArquivo =
            documentos[fieldKey] || documentosChecklistFiles[fieldKey];
          return !temArquivo;
        },
      );

      const faltandoComprovantePedido = !comprovantePublicacaoPedido;

      if (faltandoComprovantePedido) {
        setComprovantePublicacaoPedidoErro(
          "Anexe o Comprovante de Publicação de Pedido de Licença.",
        );
        setError(
          `O documento obrigatório não foi preenchido: ${DOCUMENTO_COMPROVANTE_PUBLICACAO_PEDIDO}`,
        );
        isValid = false;
      } else if (documentosObrigatoriosNaoPreenchidos.length > 0) {
        setComprovantePublicacaoPedidoErro("");
        const nomesDocumentos = documentosObrigatoriosNaoPreenchidos
          .map((doc) => doc.descricao)
          .join(", ");
        setError(
          `Os seguintes documentos obrigatórios não foram preenchidos: ${nomesDocumentos}`,
        );
        isValid = false;
      } else {
        setComprovantePublicacaoPedidoErro("");
        setError("");
      }
    }

    if (isValid) {
      if (activeStep === steps.length - 1) {
        handleSubmit();
      } else {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
    }
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const montarFormDataSolicitacao = (removerOpenAction = false) => {
    const formDataToSend = new FormData();

    formDataToSend.append("tipoLicencaId", formData.tipoLicenca?.id || "");
    formDataToSend.append("modalidade", formData.modalidade);
    formDataToSend.append("areaTotal", parseFloat(formData.areaTotal) || "");
    formDataToSend.append(
      "empreendimentoId",
      formData.empreendimento?.id || "",
    );
    formDataToSend.append("status", 0);
    formDataToSend.append(
      "descricaoDoProjeto",
      formData.descricaoProjeto || "",
    );
    formDataToSend.append("observacoes", "");
    // formDataToSend.append(
    //   "responsavelTecnicoId",
    //   formData.responsavelTecnico?.id || "",
    // );

    anexarDadosDoRepresentado(formDataToSend);

    if (removerOpenAction) {
      formDataToSend.append("removerOpenAction", "true");
    }

    if (comprovantePublicacaoPedido) {
      const extensao = comprovantePublicacaoPedido.name.split(".").pop();
      const arquivoComprovante = new File(
        [comprovantePublicacaoPedido],
        `${DOCUMENTO_COMPROVANTE_PUBLICACAO_PEDIDO}.${extensao}`,
        { type: comprovantePublicacaoPedido.type },
      );
      formDataToSend.append("ComprovantePublicacaoPedido", arquivoComprovante);
    }

    Object.keys(documentosChecklistFiles).forEach((key) => {
      const arquivo = documentosChecklistFiles[key];
      const itemId = key.replace("checklist_doc_", "");

      const checklistItem = itensChecklist.find(
        (item) => String(item.id) === itemId,
      );
      const descricao = checklistItem?.descricao || arquivo.name;

      const extensao = arquivo.name.split(".").pop();

      const novoNome = `${descricao}.${extensao}`;
      const arquivoRenomeado = new File([arquivo], novoNome, {
        type: arquivo.type,
      });

      formDataToSend.append("Documentos", arquivoRenomeado);
    });

    return formDataToSend;
  };

  const finalizarSolicitacaoComSucesso = (response) => {
    const solicitacaoId = response?.data ?? response;

    setEnvioConcluido(true);
    setSuccessMessage(
      "Solicitação enviada com sucesso! Redirecionando para a área de solicitações em 5 segundos...",
    );
    setOpenSnackbar(true);

    setTimeout(() => {
      navigate("/minhas-solicitacoes", {
        state: {
          licenca: solicitacaoId,
          message: "Solicitação enviada com sucesso!",
        },
      });
    }, 5000);
  };

  const tratarErroCriacaoSolicitacao = (errorBody) => {
    if (errorBody?.type === "pdf_open_action_detected") {
      setOpenActionDialog({
        open: true,
        message: errorBody.message || "",
        errors: Array.isArray(errorBody.errors) ? errorBody.errors : [],
      });
      return;
    }

    if (errorBody?.type === "document_upload_errors") {
      setUploadErrorsDialog({
        open: true,
        message: errorBody.message || "",
        errors: Array.isArray(errorBody.errors) ? errorBody.errors : [],
      });
      return;
    }

    if (errorBody?.message) {
      setError(errorBody.message);
      return;
    }

    setError(
      "Não foi possível enviar sua solicitação. Por favor, verifique sua conexão e tente novamente.",
    );
  };

  const handleConfirmarOpenAction = async () => {
    if (!comprovantePublicacaoPedido) {
      setOpenActionDialog({ open: false, message: "", errors: [] });
      setError(
        `O documento obrigatório não foi preenchido: ${DOCUMENTO_COMPROVANTE_PUBLICACAO_PEDIDO}`,
      );
      return;
    }

    setLoading(true);
    setError("");
    try {
      const formDataToSend = montarFormDataSolicitacao(true);
      const response = await licencasService.criarSolicitacao(formDataToSend);
      setOpenActionDialog({ open: false, message: "", errors: [] });
      finalizarSolicitacaoComSucesso(response);
    } catch (error) {
      setOpenActionDialog({ open: false, message: "", errors: [] });
      tratarErroCriacaoSolicitacao(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancelarOpenAction = () => {
    setOpenActionDialog({ open: false, message: "", errors: [] });
    setError(
      "A solicitação não será salva e não será possível concluí-la enquanto o PDF com abertura automática não tiver a remoção autorizada.",
    );
  };

  const handleSubmit = async () => {
    if (loading || envioConcluido || openActionDialog.open) {
      return;
    }

    setLoading(true);
    setError("");

    try {
      if (fluxoProtocolo) {
        const formDataToSend = new FormData();
        formDataToSend.append("processoId", formData.tipoLicenca?.id || "");
        formDataToSend.append("empreendimentoId", formData.empreendimento?.id || "");
        formDataToSend.append("modalidade", formData.modalidade);
        formDataToSend.append("especificacao", formData.especificacao || "");
        anexarDadosDoRepresentado(formDataToSend);

        Object.keys(documentosChecklistFiles).forEach((key) => {
          const arquivo = documentosChecklistFiles[key];
          const itemId = key.replace("checklist_doc_", "");
          const checklistItem = itensChecklist.find(
            (item) => String(item.id) === itemId,
          );
          const descricao = checklistItem?.descricao || arquivo.name;
          const extensao = arquivo.name.split(".").pop();
          const novoNome = `${descricao}.${extensao}`;
          const arquivoRenomeado = new File([arquivo], novoNome, {
            type: arquivo.type,
          });
          formDataToSend.append("Documentos", arquivoRenomeado);
        });

        await protocoloService.criar(formDataToSend);

        setEnvioConcluido(true);
        setSuccessMessage(
          "Protocolo enviado com sucesso! Redirecionando em 5 segundos...",
        );
        setOpenSnackbar(true);
        setTimeout(() => {
          navigate("/dashboard", {
            state: { message: "Protocolo enviado com sucesso!" },
          });
        }, 5000);
        return;
      }

      if (!comprovantePublicacaoPedido) {
        setError(
          `O documento obrigatório não foi preenchido: ${DOCUMENTO_COMPROVANTE_PUBLICACAO_PEDIDO}`,
        );
        setComprovantePublicacaoPedidoErro(
          "Anexe o Comprovante de Publicação de Pedido de Licença.",
        );
        setLoading(false);
        return;
      }

      const formDataToSend = montarFormDataSolicitacao(false);
      const response = await licencasService.criarSolicitacao(formDataToSend);
      finalizarSolicitacaoComSucesso(response);
    } catch (error) {
      tratarErroCriacaoSolicitacao(error);
    } finally {
      setLoading(false);
    }
  };

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <Grid container spacing={3}>
            {checklistNaoEncontrado && (
              <Grid item xs={12}>
                <Alert severity="error" variant="filled">
                  Não há checklist cadastrado para o tipo de empreendimento selecionado. Não é possível solicitar uma licença no momento. Por favor, entre em contato com o suporte.
                </Alert>
              </Grid>
            )}
            <Grid item xs={12} sm={12}>
              <Autocomplete
                options={tiposLicenca}
                getOptionLabel={(option) =>
                  typeof option === "string"
                    ? option
                    : option?.nome ||
                      option?.Nome ||
                      option?.codigo ||
                      option?.Codigo ||
                      ""
                }
                value={formData.tipoLicenca}
                isOptionEqualToValue={(option, value) =>
                  option?.id === value?.id
                }
                onChange={(_, newValue) =>
                  setFormData({ ...formData, tipoLicenca: newValue })
                }
                inputValue={tipoInputValue}
                onInputChange={(_, newInput) => setTipoInputValue(newInput)}
                noOptionsText={
                  tipoInputValue && tipoInputValue.trim().length >= 3
                    ? "Nenhum tipo encontrado"
                    : "Digite 3 ou mais letras"
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Tipo de Licença"
                    placeholder="Ex: Licença Prévia"
                    required
                    fullWidth
                    InputProps={{
                      ...params.InputProps,
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={12}>
              <FormControl fullWidth required>
                <InputLabel id="modalidade-label">Modalidade</InputLabel>
                <Select
                  labelId="modalidade-label"
                  id="modalidade-select"
                  name="modalidade"
                  value={formData.modalidade}
                  onChange={handleChange}
                  label="Modalidade"
                  error={formData.modalidade === "" && error.includes("modalidade")}
                >
                  <MenuItem value="">
                    <em>Selecione uma modalidade</em>
                  </MenuItem>
                  {modalidadeEnum.map((mod) => (
                    <MenuItem key={mod.value} value={mod.value}>
                      {mod.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel id="empreendimento-label">
                  Empreendimento
                </InputLabel>
                <Select
                  labelId="empreendimento-label"
                  id="empreendimento"
                  name="empreendimento"
                  value={formData.empreendimento?.id || ""}
                  onChange={(e) => {
                    const empreendimentoSelected = empreendimentos.find(
                      (emp) => emp.id.toString() === e.target.value.toString(),
                    );
                    setFormData({
                      ...formData,
                      empreendimento: empreendimentoSelected || null,
                    });
                  }}
                  label="Empreendimento"
                  required
                >
                  <MenuItem value="">Selecione...</MenuItem>
                  {empreendimentos.map((emp) => (
                    <MenuItem key={emp.id} value={emp.id}>
                      {emp.nome}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {usuarioConsultor && (
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={solicitadoPorRepresentado}
                      onChange={handleSolicitadoPorRepresentadoChange}
                    />
                  }
                  label="Sou consultor e estou solicitando a licença por outra pessoa"
                />
                {solicitadoPorRepresentado && (
                  <FormControl fullWidth required sx={{ mt: 1 }}>
                    <InputLabel id="representado-label">Representado</InputLabel>
                    <Select
                      labelId="representado-label"
                      id="representado-select"
                      value={representadoId}
                      onChange={(event) => setRepresentadoId(event.target.value)}
                      label="Representado"
                      disabled={carregandoRepresentados}
                    >
                      <MenuItem value="">
                        <em>Selecione o representado</em>
                      </MenuItem>
                      {representados.map((representado) => (
                        <MenuItem key={representado.id} value={representado.id}>
                          {obterNomeExibicaoRepresentado(representado)}
                        </MenuItem>
                      ))}
                    </Select>
                    {!carregandoRepresentados && representados.length === 0 && (
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ mt: 0.5 }}
                      >
                        Nenhum representado cadastrado. Cadastre em Alterar
                        Dados &gt; Representados.
                      </Typography>
                    )}
                  </FormControl>
                )}
              </Grid>
            )}

            {/* Responsável Técnico desativado
            <Grid item xs={12}>
              <Autocomplete
                id="responsavel-tecnico"
                options={responsaveisTecnicos}
                getOptionLabel={(option) => `${option.nome}`}
                value={formData.responsavelTecnico}
                onChange={(event, newValue) => {
                  setFormData({
                    ...formData,
                    responsavelTecnico: newValue,
                  });
                }}
                inputValue={termoBuscaResponsavel}
                onInputChange={(event, newInputValue) => {
                  setTermoBuscaResponsavel(newInputValue);
                }}
                loading={carregandoResponsaveis}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Responsável Técnico"
                    helperText="Digite no mínimo 3 letras para buscar"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {carregandoResponsaveis ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}
                  />
                )}
                noOptionsText="Nenhum responsável técnico encontrado"
              />
            </Grid>
            */}
          </Grid>
        );
      case 1:
        if (fluxoProtocolo) {
          return (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  required
                  label="Especificação"
                  name="especificacao"
                  multiline
                  rows={4}
                  value={formData.especificacao}
                  onChange={handleChange}
                  inputProps={{ maxLength: 100 }}
                  helperText="Descreva a especificação da solicitação florestal (máx. 100 caracteres)"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <CharCounter
                          value={formData.especificacao}
                          maxLength={100}
                        />
                      </InputAdornment>
                    ),
                    sx: {
                      borderRadius: 2,
                      transition: "all 0.3s",
                      "&:hover": {
                        boxShadow: "0 0 0 2px rgba(0, 123, 85, 0.1)",
                      },
                      "&.Mui-focused": {
                        boxShadow: "0 0 0 2px rgba(0, 123, 85, 0.2)",
                      },
                    },
                  }}
                />
              </Grid>
            </Grid>
          );
        }
        return (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                required
                label="Descrição do Projeto"
                name="descricaoProjeto"
                multiline
                rows={8}
                value={formData.descricaoProjeto}
                onChange={handleChange}
                placeholder="Descreva detalhadamente seu projeto..."
                inputProps={{ maxLength: 2000 }}
                helperText="Seja específico sobre aspectos técnicos e impactos ambientais"
                InputProps={{
                  sx: {
                    borderRadius: 2,
                    transition: "all 0.3s",
                    "&:hover": {
                      boxShadow: "0 0 0 2px rgba(0, 123, 85, 0.1)",
                    },
                    "&.Mui-focused": {
                      boxShadow: "0 0 0 2px rgba(0, 123, 85, 0.2)",
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                label="Área Total (m²)"
                name="areaTotal"
                type="number"
                value={formData.areaTotal}
                onChange={handleChange}
                placeholder="Ex: 1000"
                helperText="Área total em metros quadrados"
                InputProps={{
                  sx: {
                    borderRadius: 2,
                    transition: "all 0.3s",
                    "&:hover": {
                      boxShadow: "0 0 0 2px rgba(0, 123, 85, 0.1)",
                    },
                    "&.Mui-focused": {
                      boxShadow: "0 0 0 2px rgba(0, 123, 85, 0.2)",
                    },
                  },
                }}
              />
            </Grid>
          </Grid>
        );
      case 2:
        return (
          <Box component="form" onSubmit={handleNext}>
            <Typography
              variant="h6"
              component="h3"
              gutterBottom
              sx={{
                display: "flex",
                alignItems: "center",
                color: accentHeadingColor,
              }}
            >
              <Box component="span" sx={{ mr: 1, fontSize: "1.4rem" }}>
                ✓
              </Box>
              Documentos padrão
            </Typography>
            <Box sx={{ mb: 4 }}>
              <DocumentosPadraoUpload
                arquivo={comprovantePublicacaoPedido}
                erro={comprovantePublicacaoPedidoErro}
                onFileChange={(arquivo) => {
                  setComprovantePublicacaoPedido(arquivo);
                  setComprovantePublicacaoPedidoErro("");
                }}
              />
            </Box>

            <Typography
              variant="h6"
              component="h3"
              gutterBottom
              sx={{
                display: "flex",
                alignItems: "center",
                color: accentHeadingColor,
              }}
            >
              <Box component="span" sx={{ mr: 1, fontSize: "1.4rem" }}>
                ✓
              </Box>
              Documentos do checklist
            </Typography>
            {Object.keys(documentosErros).length > 0 && (
              <Alert
                severity="warning"
                sx={{
                  mb: 3,
                  borderRadius: 2,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                }}
                variant="filled"
              >
                Há documentos obrigatórios que não foram anexados ou estão com
                problemas. Por favor, verifique os campos marcados em vermelho.
              </Alert>
            )}
            <ChecklistDocumentosUpload
              itensChecklist={itensChecklist}
              documentosErros={documentosErros}
              documentos={documentos}
              documentosChecklistFiles={documentosChecklistFiles}
              onFileChange={(itemId, arquivo) => {
                const fieldKey = `checklist_doc_${itemId}`;
                setDocumentosChecklistFiles((prev) => ({
                  ...prev,
                  [fieldKey]: arquivo,
                }));
              }}
            />

            <Grid container spacing={3}>
              <Grid item xs={12}>
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <FormLabel sx={{ mb: 1, fontWeight: "medium" }}>
                    Observações
                  </FormLabel>
                  <TextField
                    multiline
                    rows={4}
                    value={formData.observacoes}
                    onChange={(e) =>
                      setFormData({ ...formData, observacoes: e.target.value })
                    }
                    placeholder="Informações adicionais que possam ser relevantes para a análise"
                    inputProps={{ maxLength: 2000 }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                        transition: "all 0.3s",
                        "&:hover": {
                          boxShadow: "0 0 0 2px rgba(0, 123, 85, 0.1)",
                        },
                        "&.Mui-focused": {
                          boxShadow: "0 0 0 2px rgba(0, 123, 85, 0.2)",
                        },
                      },
                    }}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Box>
        );
      case 3:
        if (fluxoProtocolo) {
          return (
            <Box>
              <Typography
                variant="h6"
                component="h3"
                gutterBottom
                color={primaryHeadingColor}
                sx={{ display: "flex", alignItems: "center", mb: 3 }}
              >
                <Box component="span" sx={{ mr: 1, fontSize: "1.4rem" }}>✓</Box>
                Revisão do Protocolo
              </Typography>
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  mb: 3,
                  borderRadius: 2,
                  border: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
                }}
              >
                <RevisaoProtocoloPanel
                  processoNome={
                    formData.tipoLicenca?.nome || formData.tipoLicenca?.Nome
                  }
                  empreendimento={formData.empreendimento}
                  especificacao={formData.especificacao}
                  usuario={usuarioAtual}
                  requerente={requerenteRepresentado}
                />
              </Paper>
              <Box
                sx={{
                  p: 3,
                  borderRadius: 2,
                  bgcolor: alpha(theme.palette.info.light, 0.1),
                  border: `1px solid ${alpha(theme.palette.info.main, 0.2)}`,
                }}
              >
                <Typography variant="body2" color={infoTextColor}>
                  Revise cuidadosamente todas as informações. Após o envio, o
                  protocolo será registrado. O PDF do requerimento ficará
                  disponível para download quando o status for Emitido.
                </Typography>
              </Box>
            </Box>
          );
        }
        return (
          <Box>
            <Typography
              variant="h6"
              component="h3"
              gutterBottom
              color={primaryHeadingColor}
              sx={{
                display: "flex",
                alignItems: "center",
                mb: 3,
              }}
            >
              <Box component="span" sx={{ mr: 1, fontSize: "1.4rem" }}>
                ✓
              </Box>
              Revisão da Solicitação
            </Typography>

            <Paper
              elevation={0}
              sx={{
                p: 3,
                mb: 4,
                borderRadius: 2,
                border: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
                bgcolor: alpha(theme.palette.background.paper, 0.7),
              }}
            >
              <Typography
                variant="subtitle1"
                gutterBottom
                fontWeight="bold"
                color="text.secondary"
                sx={{
                  pb: 1,
                  borderBottom: `1px solid ${alpha(
                    theme.palette.divider,
                    0.3,
                  )}`,
                  mb: 2,
                }}
              >
                Informações Básicas
              </Typography>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <Box
                      component="span"
                      sx={{
                        width: 38,
                        height: 38,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: alpha(theme.palette.primary.main, 0.1),
                        color: theme.palette.primary.main,
                        fontSize: "1.2rem",
                        mr: 2,
                      }}
                    >
                      🏷️
                    </Box>
                    <Box>
                      <Typography variant="caption" color="text.secondary">
                        Tipo de Licença
                      </Typography>
                      <Typography variant="subtitle1" fontWeight="medium">
                        {formData.tipoLicenca?.nome ||
                          formData.tipoLicenca?.Nome ||
                          formData.tipoLicenca?.label ||
                          "—"}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <Box
                      component="span"
                      sx={{
                        width: 38,
                        height: 38,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: alpha(theme.palette.primary.main, 0.1),
                        color: theme.palette.primary.main,
                        fontSize: "1.2rem",
                        mr: 2,
                      }}
                    >
                      📏
                    </Box>
                    <Box>
                      <Typography variant="caption" color="text.secondary">
                        Área Total
                      </Typography>
                      <Typography variant="subtitle1" fontWeight="medium">
                        {formData.areaTotal} m²
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                {formData.empreendimento && (
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                      <Box
                        component="span"
                        sx={{
                          width: 38,
                          height: 38,
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: alpha(
                            theme.palette.primary.main,
                            0.1,
                          ),
                          color: theme.palette.primary.main,
                          fontSize: "1.2rem",
                          mr: 2,
                        }}
                      >
                        🏢
                      </Box>
                      <Box>
                        <Typography variant="caption" color="text.secondary">
                          Empreendimento
                        </Typography>
                        <Typography variant="subtitle1" fontWeight="medium">
                          {formData.empreendimento?.nome || "—"}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                )}

                {representadoSelecionado && (
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                      <Box
                        component="span"
                        sx={{
                          width: 38,
                          height: 38,
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: alpha(
                            theme.palette.primary.main,
                            0.1,
                          ),
                          color: theme.palette.primary.main,
                          fontSize: "1.2rem",
                          mr: 2,
                        }}
                      >
                        🤝
                      </Box>
                      <Box>
                        <Typography variant="caption" color="text.secondary">
                          Solicitado em nome de
                        </Typography>
                        <Typography variant="subtitle1" fontWeight="medium">
                          {obterNomeExibicaoRepresentado(
                            representadoSelecionado,
                            "—",
                          )}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                )}

                {/* {formData.responsavelTecnico && (
                  <Grid item xs={12}>
                    <Box
                      sx={{ display: "flex", alignItems: "flex-start", mb: 2 }}
                    >
                      <Box
                        component="span"
                        sx={{
                          width: 38,
                          height: 38,
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: alpha(
                            theme.palette.primary.main,
                            0.1,
                          ),
                          color: theme.palette.primary.main,
                          fontSize: "1.2rem",
                          mr: 2,
                          mt: 0.5,
                        }}
                      >
                        👨‍🔬
                      </Box>
                      <Box>
                        <Typography variant="caption" color="text.secondary">
                          Responsável Técnico
                        </Typography>
                        <Typography variant="subtitle1" fontWeight="medium">
                          {formData.responsavelTecnico?.nome || "—"}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                )} */}
              </Grid>
            </Paper>

            <Paper
              elevation={0}
              sx={{
                p: 3,
                mb: 4,
                borderRadius: 2,
                border: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
                bgcolor: alpha(theme.palette.background.paper, 0.7),
              }}
            >
              <Typography
                variant="subtitle1"
                gutterBottom
                fontWeight="bold"
                color="text.secondary"
                sx={{
                  pb: 1,
                  borderBottom: `1px solid ${alpha(
                    theme.palette.divider,
                    0.3,
                  )}`,
                  mb: 2,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Box component="span" sx={{ mr: 1, fontSize: "1.2rem" }}>
                  📝
                </Box>
                Descrição do Projeto
              </Typography>

              <Box sx={{ px: 1 }}>
                <Typography
                  variant="body1"
                  sx={{ whiteSpace: "pre-line", color: "text.primary" }}
                >
                  {formData.descricaoProjeto || "Nenhuma descrição fornecida."}
                </Typography>
              </Box>
            </Paper>

            <Paper
              elevation={0}
              sx={{
                p: 3,
                mb: 4,
                borderRadius: 2,
                border: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
                bgcolor: alpha(theme.palette.background.paper, 0.7),
              }}
            >
              <Typography
                variant="subtitle1"
                gutterBottom
                fontWeight="bold"
                color="text.secondary"
                sx={{
                  pb: 1,
                  borderBottom: `1px solid ${alpha(
                    theme.palette.divider,
                    0.3,
                  )}`,
                  mb: 2,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Box component="span" sx={{ mr: 1, fontSize: "1.2rem" }}>
                  📎
                </Box>
                Documentos Anexados
              </Typography>

              <Grid container spacing={2}>
                {comprovantePublicacaoPedido ? (
                  <RevisaoDocumentoCard
                    titulo={DOCUMENTO_COMPROVANTE_PUBLICACAO_PEDIDO}
                    nomeArquivo={comprovantePublicacaoPedido.name}
                    anexado
                  />
                ) : (
                  <RevisaoDocumentoCard
                    titulo={DOCUMENTO_COMPROVANTE_PUBLICACAO_PEDIDO}
                    anexado={false}
                  />
                )}
                {itensChecklist.map((doc) => {
                  const arquivo = obterArquivoDoItemChecklist(
                    doc,
                    documentosChecklistFiles,
                    documentos,
                  );

                  if (arquivo) {
                    return (
                      <RevisaoDocumentoCard
                        key={doc.id}
                        titulo={doc.descricao}
                        nomeArquivo={arquivo.name}
                        anexado
                      />
                    );
                  }

                  if (doc.obrigatorio) {
                    return (
                      <RevisaoDocumentoCard
                        key={doc.id}
                        titulo={doc.descricao}
                        anexado={false}
                      />
                    );
                  }

                  return null;
                })}
                {itensChecklist.length === 0 && (
                  <Grid item xs={12}>
                    <Typography variant="body2" color="text.secondary">
                      Nenhum documento do checklist.
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </Paper>

            {formData.observacoes && (
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  mb: 4,
                  borderRadius: 2,
                  border: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
                  bgcolor: alpha(theme.palette.background.paper, 0.7),
                }}
              >
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  fontWeight="bold"
                  color="text.secondary"
                  sx={{
                    pb: 1,
                    borderBottom: `1px solid ${alpha(
                      theme.palette.divider,
                      0.3,
                    )}`,
                    mb: 2,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Box component="span" sx={{ mr: 1, fontSize: "1.2rem" }}>
                    💬
                  </Box>
                  Observações
                </Typography>

                <Box sx={{ px: 1 }}>
                  <Typography
                    variant="body1"
                    sx={{ whiteSpace: "pre-line", color: "text.primary" }}
                  >
                    {formData.observacoes}
                  </Typography>
                </Box>
              </Paper>
            )}

            <Box
              sx={{
                p: 3,
                mb: 3,
                borderRadius: 2,
                bgcolor: alpha(theme.palette.info.light, 0.1),
                border: `1px solid ${alpha(theme.palette.info.main, 0.2)}`,
                display: "flex",
                alignItems: "flex-start",
              }}
            >
              <Box
                component="span"
                sx={{ mr: 2, color: "info.main", fontSize: "1.4rem", mt: 0.5 }}
              >
                ℹ️
              </Box>
              <Typography variant="body2" color={infoTextColor}>
                Revise cuidadosamente todas as informações fornecidas. Após o
                envio, não será possível editar a solicitação. Você poderá
                acompanhar o status do processo na página "Minhas Solicitações".
              </Typography>
            </Box>
          </Box>
        );
      default:
        return null;
    }
  };

  return (
    <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
      <Box sx={{ mt: { xs: 3, md: 6 }, mb: 8 }}>
        <Paper
          elevation={3}
          data-testid="nova-solicitacao-paper"
          sx={{
            p: { xs: 2, sm: 3, md: 5 },
            borderRadius: 3,
            boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
            backgroundColor: "background.paper",
            position: "relative",
            overflow: "hidden",
            "&:before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: "8px",
              background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.success.main})`,
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mb: 5,
              flexDirection: { xs: "column", sm: "row" },
              textAlign: { xs: "center", sm: "left" },
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: 60,
                height: 60,
                borderRadius: "50%",
                backgroundColor: alpha(theme.palette.primary.main, 0.1),
                mb: { xs: 2, sm: 0 },
                mr: { sm: 3 },
              }}
            >
              <DescriptionIcon
                sx={{
                  fontSize: 32,
                  color: theme.palette.primary.main,
                }}
              />
            </Box>
            <Typography
              variant="h4"
              component="h1"
              sx={{
                fontWeight: 700,
                color: theme.palette.primary.main,
                fontSize: { xs: "1.1rem", md: "1.5rem" },
              }}
            >
              Nova Solicitação de Licença
            </Typography>
          </Box>

          <Stepper
            activeStep={activeStep}
            orientation={isMobile ? "vertical" : "horizontal"}
            alternativeLabel={!isMobile}
            sx={{
              mb: 5,
              p: { xs: 1, md: 2 },
              backgroundColor: alpha(theme.palette.primary.light, 0.05),
              borderRadius: 2,
              "& .MuiStepLabel-label": {
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                color: "text.secondary",
              },
              "& .MuiStepLabel-label.Mui-active, & .MuiStepLabel-label.Mui-completed":
                {
                  color: "text.primary",
                },
              "& .MuiStepIcon-root": {
                color: "action.disabled",
              },
              "& .MuiStepIcon-root.Mui-active, & .MuiStepIcon-root.Mui-completed":
                {
                  color: "primary.main",
                },
            }}
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          {error && (
            <Alert
              severity="error"
              sx={{ mb: 4, borderRadius: 2 }}
              variant="filled"
            >
              {error}
            </Alert>
          )}

          <Box sx={{ mt: 4, mb: 5, minHeight: "300px" }}>
            <Typography
              ref={stepHeadingRef}
              variant="h6"
              component="h2"
              tabIndex={-1}
              gutterBottom
              sx={{ fontWeight: 600 }}
            >
              {steps[activeStep]}
            </Typography>
            {renderStepContent(activeStep)}
          </Box>

          <Stack
            direction={{ xs: "column-reverse", sm: "row" }}
            spacing={2}
            justifyContent="space-between"
            alignItems={{ xs: "stretch", sm: "center" }}
            sx={{
              mt: 5,
              pt: 3,
              borderTop: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
            }}
          >
            {activeStep > 0 ? (
              <Button
                onClick={handleBack}
                variant="outlined"
                fullWidth
                sx={{
                  borderRadius: 30,
                  textTransform: "none",
                  pl: 3,
                  pr: 3,
                  py: 1,
                  width: { xs: "100%", sm: "auto" },
                }}
                startIcon={<span>←</span>}
              >
                Voltar
              </Button>
            ) : (
              <Box />
            )}

            {activeStep === steps.length - 1 ? (
              <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={loading || envioConcluido || openActionDialog.open}
                fullWidth
                sx={{
                  borderRadius: 30,
                  textTransform: "none",
                  pl: 4,
                  pr: 4,
                  py: 1.2,
                  fontWeight: 600,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                  width: { xs: "100%", sm: "auto" },
                }}
                endIcon={<CloudUploadIcon />}
              >
                {loading
                  ? "Enviando..."
                  : envioConcluido
                    ? "Enviado"
                    : fluxoProtocolo
                      ? "Enviar Protocolo"
                      : "Enviar Solicitação"}
              </Button>
            ) : (
              <Button
                variant="contained"
                onClick={handleNext}
                disabled={activeStep === 0 && checklistNaoEncontrado}
                fullWidth
                sx={{
                  borderRadius: 30,
                  textTransform: "none",
                  pl: 4,
                  pr: 4,
                  py: 1.2,
                  fontWeight: 600,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                  width: { xs: "100%", sm: "auto" },
                }}
                endIcon={<span>→</span>}
              >
                Próximo
              </Button>
            )}
          </Stack>
        </Paper>
      </Box>

      <PdfOpenActionConfirmDialog
        open={openActionDialog.open}
        message={openActionDialog.message}
        errors={openActionDialog.errors}
        loading={loading}
        onConfirm={handleConfirmarOpenAction}
        onCancel={handleCancelarOpenAction}
      />

      <ErrosUploadDocumentosModal
        open={uploadErrorsDialog.open}
        message={uploadErrorsDialog.message}
        errors={uploadErrorsDialog.errors}
        onClose={() =>
          setUploadErrorsDialog({ open: false, message: "", errors: [] })
        }
      />

      <Snackbar
        open={openSnackbar}
        autoHideDuration={5000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity="success"
          sx={{ width: "100%" }}
          elevation={6}
          variant="filled"
        >
          {successMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
}

export default NovaSolicitacao;
